import React, { useMemo } from 'react'
import { useTransferActive, useTransferData } from '../hooks/transfer-data'
import { TransferProgress } from './transfer-progress'
import { Card } from '../../card/card'
import { ButtonPrimary, ButtonSecondary } from '../../component/button'
import { useTransferContext } from '../transfer-provider'
import { TRANSFER_EVENT_FAILED } from '../transfer-types/upload-base'
import { transferFailedText } from '../transfer-status'

export const TransferCopyNodeStatus = ({ transfer, allowGoto, gotoText, onGoTo }) => {
  const transferContext = useTransferContext()

  const transferData = useTransferData(transfer)

  const active = useTransferActive(transfer)

  const show = useMemo(() => !!transfer, [transfer])

  const failed = transferData.status === TRANSFER_EVENT_FAILED

  const handleClose = () => {
    transferContext.handleRemoveTransfer(transfer.id)
  }

  const handleGoTo = () => {
    onGoTo && onGoTo(transferData.msgData.nodeID)
    transferContext.handleRemoveTransfer(transfer.id)
  }

  const skippedFiles = useMemo(() => (transferData.msgData && transferData.msgData.skippedFiles) || [], [transferData])

  return (
    <React.Fragment>
      {show &&
        <div className="p-2">
          <Card>
            <label className="p-1">
              {active ? <span>Copying data...</span> : failed ? <span>The copy didn't finish</span> : <span>Copy complete</span>}
            </label>
            <TransferProgress transferData={transferData} />
            {failed &&
              <div className="m-1 alert alert-danger" role="alert" data-testid="copy-failed">
                {transferFailedText(transferData)}
              </div>}
            {!active && skippedFiles.length > 0 &&
              <div className="m-1 alert alert-warning" role="alert">
                <div>{transferData.msgData.message}</div>
                <ul className="mb-0">
                  {skippedFiles.map((file, index) =>
                    <li key={index}>
                      {file.assetName} (version {file.version})
                    </li>)}
                </ul>
              </div>}
            <div className="m-1">
              {active
                ? <BackgroundMessage />
                : <div>
                    {allowGoto && !failed && <ButtonPrimary text={gotoText} disabled={active} onClick={handleGoTo} />}
                    <ButtonSecondary text="close" onClick={handleClose} />
                  </div>}
            </div>
          </Card>
        </div>}
    </React.Fragment>
  )
}

export const BackgroundMessage = () => {
  return <div className="p-2">Process running in background</div>
}
